import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportToPDF = (title, headers, data, fileName = 'report.pdf') => {
  const doc = new jsPDF('l', 'mm', 'a4');

  // Header
  doc.setFontSize(18);
  doc.setTextColor(30, 58, 138);
  doc.text("Embu County ICRMS: Performance Analysis and Reporting", 14, 15);

  doc.setFontSize(12);
  doc.setTextColor(100);
  doc.text(title, 14, 22);
  doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 28);

  // ✅ Use autoTable function directly
  autoTable(doc, {
    startY: 35,
    head: [headers],
    body: data,
    theme: 'grid',
    headStyles: { fillColor: [30, 58, 138], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 247, 250] },
    styles: { fontSize: 9, cellPadding: 3 }
  });

  doc.save(fileName);
};